import { useEffect, useContext, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { V2ConfigurationContext } from 'contexts/Configuration'
import { useAnalytics } from 'analytics'

import Header from './Header'
import PoweredBy from './PoweredBy'

const SingleStyleButton = ({ onClick, onImpression }) => {
  const { t } = useTranslation()
  const buttonRef = useRef(null)

  const { buttonCopy } = useContext(V2ConfigurationContext)

  const analytics = useAnalytics()

  const buttonLabel = buttonCopy || t('shopButton')

  // Setup IntersectionObserver to send impression event
  useEffect(() => {
    let observer = null
    if (buttonRef?.current) {
      // The IntersectionObserver should add on content of shadow DOM, not the root element.
      // Otherwise, the callback will not be called
      observer = new IntersectionObserver(onImpression, { threshold: 1 })
      observer.observe(buttonRef.current)
    }
    return () => {
      if (observer) observer.disconnect()
    }
  }, [buttonRef, analytics])

  return (
    <Container ref={buttonRef}>
      <Header />
      <Button onClick={onClick}>{buttonLabel}</Button>
      <PoweredBy />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 310px;
  max-width: 100%;
`

const Button = styled.button`
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  border-radius: var(--sc-widget-button-border-radius, 22px);
  text-align: center;
  cursor: pointer;
  padding: 12px 14px;
  margin-bottom: 8px;
  box-shadow: var(--sc-widget-button-shadow, 0px 2px 16px rgba(0, 0, 0, 0.12));
  text-transform: uppercase;
  background-color: var(--sc-widget-button-background-color, #000000);
  color: var(--sc-widget-button-text-color, #FFFFFF);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
`

export default SingleStyleButton
